export enum PlayerStatus {
  Online = 'ONLINE',
  Offline = 'OFFLINE',
  Pending = 'PENDING',
}
